
<div style="width: 100%; min-width: 900px; overflow: auto;">
<kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
            [groupable]="true" [resizable]="true" [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
            (sortChange)="sortChange($event)" style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize"
            [pageable]="true">

  <ng-template kendoGridToolbarTemplate position="top">
    <button  (click)="onAddClick()" kendoButton class="btn btn-primary">
      <fa-icon icon="circle-plus"></fa-icon> Add Evaluation Rating Scale </button>
  </ng-template>

  <kendo-grid-column title="Edit" [width]="60">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onEditClick(dataItem)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="edit"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="rating_scale_value" title="Rating Scale Value" [width]="80">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="rating_scale_name" title="Scale Title" [width]="140">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="rating_scale_description" title="Description" [width]="200">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Activate / Deactivate" field="active" [width]="80">
    <ng-template kendoGridCellTemplate let-dataItem>
      <input type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active" (click)="setActive(dataItem)"  />
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <ng-template kendoPagerTemplate>
    <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
  </ng-template>

</kendo-grid>

<kendo-dialog-actions>
  <button kendoButton (click)="onCancelAction()" class="btn btn-primary">Close</button>
</kendo-dialog-actions>
</div>

